import { all, AllEffect, ForkEffect } from 'redux-saga/effects'

import accountSaga from './AccountSaga/accountSaga'
import appointmentsSearchSaga from './AppointmentSearchSaga'
import contactInfoSagas from './ContactInfoSaga'
import forgotPasswordSagas from './ForgotPasswordSaga/forgotPasswordSaga'
import loginSaga from './LoginSaga'
import ssoLoginSaga from './SSOLoginSaga/SSOLoginSaga'
import passwordSagas from './PasswordSaga'
import patientSearchSaga from './PatientSearchSaga'
import recoverUsernameSaga from './RecoverUsernameSaga'
import registerAccountSagas from './RegisterAccountSaga'
import addPracticeSaga from './AddPracticeSaga'
import resetPasswordSaga from './ResetPasswordSaga'
import patientReportSaga from './PatientReportSaga'
import patientImagesSaga from './PatientImagesSaga/PatientImagesSaga'
import patientDetailsSaga from './PatientDetailsSaga/PatientDetailsSaga'
import patientStudiesSaga from './PatientStudiesSaga/PatientStudiesSaga'
import referralSaga from './ReferralSaga/referralSaga'
import acceptTCSaga from './AcceptTCSaga/AcceptTCSaga'
import webcomradPasswordResetSaga from './WebcomradPasswordResetSaga'
import alfredMaterImagingSagas from './AlfredMaterImagingSaga'
import removePracticeSaga from './RemovePracticeSaga/RemovePracticeSaga'
import billingGuideSaga from './BillingGuideSaga'

export default function* rootSaga(): Generator<AllEffect<ForkEffect<void>>, void, unknown> {
  yield all([
    ...loginSaga,
    ...ssoLoginSaga,
    ...accountSaga,
    ...registerAccountSagas,
    ...recoverUsernameSaga,
    ...contactInfoSagas,
    ...passwordSagas,
    ...addPracticeSaga,
    ...removePracticeSaga,
    ...forgotPasswordSagas,
    ...resetPasswordSaga,
    ...patientSearchSaga,
    ...patientReportSaga,
    ...patientImagesSaga,
    ...patientDetailsSaga,
    ...patientStudiesSaga,
    ...appointmentsSearchSaga,
    ...referralSaga,
    ...acceptTCSaga,
    ...webcomradPasswordResetSaga,
    ...alfredMaterImagingSagas,
    ...billingGuideSaga,
  ])
}
